export default __webpack_public_path__ + "static/media/BrainBreak cards89.ea884905.png";